import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FloatingLabel, Alert } from 'react-bootstrap';
import { useAuth } from '../../utils/auth';
import { AdminControl } from '../../utils/admin';
import OtpPage from './OtpPage';

const SecretLoginPage = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const [urlParams] = useSearchParams();
  const [notice, setNotice] = useState(null);
  const [requiresOTP, setRequiresOTP] = useState(false);
  const { t, i18n } = useTranslation();
  const confirmed = urlParams.get('confirmed');

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required(t('errors.requiredEmail'))
      .email(t('errors.validEmail')),
    password: Yup.string()
      .required(t('errors.requiredPassword'))
      .min(8, t('errors.validPassword'))
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, formState: { errors } } = useForm(formOptions);

  useEffect(() => {
    if (auth.role && auth.role === 'artist') navigate('/');
    else if (auth.role && auth.role === 'regional-juror') navigate(t('routes:juror-dashboard'));
    else if (auth.role && (auth.role === 'international-juror' || auth.role === 'head-juror' ||  auth.role === 'collaborator')) navigate(t('routes:national-results'));
    else if (auth.role && auth.role === 'admin') navigate('/admin-settings');
  }, [auth]);

  useEffect(() => {
    if (confirmed)
      setNotice(
        <Alert variant="success">
          <p>{t('signIn.activatedSuccess')}</p>
        </Alert>
      );
  }, [confirmed, t]);

  /* const onSubmit = data => {
    auth.signIn(data.email, data.password, i18n.language, res => {
      if (res.error) {
        setNotice(<Alert variant="danger"><p>{res.error}</p></Alert>);
      } else {
        if (res.role === 'artist') {
          navigate('/');
        } else if (res.role === 'regional-juror') {
          navigate(t('routes:juror-dashboard'));
        } else {
          navigate(t('routes:national-results'));
        }
      }
    });
  }; */
  const onSubmit = data => {
    auth.signIn(data.email, data.password, i18n.language, res => {
      if (res.error) {
        setNotice(<Alert variant="danger"><p>{res.error}</p></Alert>);
      } else {
        // check for OTP
        if (res.otpCode) {
          setRequiresOTP(res.email);
        } else {
          // Else Login
          if (res.role === 'artist') {
            navigate('/');
          } else if (res.role === 'regional-juror') {
            navigate(t('routes:juror-dashboard'));
          } else {
            navigate(t('routes:national-results'));
          }
        }
      }
    });
  };

  if (requiresOTP) {
    return <OtpPage email={requiresOTP} />
  }

  return (
    <div className="container">
      <div className="row g-3 justify-content-center">
    		<div className="col col-12 col-lg-4">
          {/** Using dangerouslySetInnerHTML here so that we properly register non-breaking spaces &nbsp; */}
          <h1 style={{marginBottom: 0}} dangerouslySetInnerHTML={{ __html: t('home.title')}} />
    			<h2>{t('signIn.title')}</h2>
    		</div>
    	</div>

      <div className="row g-3 mb-5 justify-content-md-center">
      	<div className="col col-12 col-lg-4">
          {notice}
          { errors.email &&
            <Alert variant="danger"><p>{errors.email.message}</p></Alert>
          }
          { errors.password &&
            <Alert variant="danger"><p>{errors.password.message}</p></Alert>
          }
          <form onSubmit={handleSubmit(onSubmit)}>
            <FloatingLabel
              controlId="email"
              label={t('forms.email')}
              className="mb-4"
            >
              <input
                className="form-control"
                type="email"
                autoComplete="email"
                placeholder="name@example.com"
                {...register('email')}
              />
            </FloatingLabel>

            <FloatingLabel
              controlId="password"
              label={t('forms.password')}
              className="mb-4"
            >
              <input
                className="form-control"
                type="password"
                autoComplete="current-password"
                placeholder="********"
                {...register('password')}
              />
  					</FloatingLabel>

            <button
              className="btn btn-lg"
              type="submit">
              {t('signIn.title')}
              <i className="fa fa-chevron-right ml-3"></i>
            </button>
          </form>
        </div>
      </div>

      <div className="row g-3 mb-5 justify-content-md-center">
        <div className="col col-12 col-lg-4 text-center">
          <Link to={t('routes:sign-up')}>{t('signUp.title')}</Link><br />
          <Link to={t('routes:forgot-password')}>{t('passwordReset.title1')}</Link>
        </div>
      </div>
    </div>
  );
}

export default SecretLoginPage;